import React from 'react';
import {
  FeaturesListContainer,
  FeatureListItem,
  FeatureNumber,
  FeatureListContent,
  FeatureListIcon,
  FeatureListText,
  FeatureListTitle,
  FeatureListDesc,
  FeatureArrow
} from './styles';

interface Feature {
  icon: React.ReactNode;
  title: string;
  description: string;
  detail: string;
}

interface FeaturesListProps {
  features: Feature[];
  activeFeature: number;
  hoveredFeature: number | null;
  onFeatureClick: (index: number) => void;
  onFeatureHover: (index: number | null) => void;
}

const FeaturesList: React.FC<FeaturesListProps> = ({
  features,
  activeFeature,
  hoveredFeature,
  onFeatureClick,
  onFeatureHover
}) => {
  return (
    <FeaturesListContainer>
      {features.map((feature, index) => (
        <FeatureListItem
          key={index}
          $active={activeFeature === index}
          $hovered={hoveredFeature === index}
          onMouseEnter={() => {
            onFeatureHover(index);
            onFeatureClick(index);
          }}
          onMouseLeave={() => onFeatureHover(null)}
          onClick={() => onFeatureClick(index)}
          $delay={index * 100}
        >
          <FeatureNumber $active={activeFeature === index || hoveredFeature === index}>
            {String(index + 1).padStart(2, '0')}
          </FeatureNumber>
          <FeatureListContent>
            <FeatureListIcon $active={activeFeature === index || hoveredFeature === index}>
              {feature.icon}
            </FeatureListIcon>
            <FeatureListText>
              <FeatureListTitle>{feature.title}</FeatureListTitle>
              <FeatureListDesc>{feature.description}</FeatureListDesc>
            </FeatureListText>
          </FeatureListContent>
          <FeatureArrow $active={activeFeature === index || hoveredFeature === index}>
            <svg viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
            </svg>
          </FeatureArrow>
        </FeatureListItem>
      ))}
    </FeaturesListContainer>
  );
};

export default FeaturesList;
